import Vue from 'vue';
import moment from 'moment-timezone';
import DatepickerDefault from 'vuejs-datepicker';
import Language from 'vuejs-datepicker/src/locale/Language';
import { apiToLocalDate, localDateToApi } from '@/util/helper';

const Datepicker = Vue.component('datepicker', {
  extends: DatepickerDefault,
  data() {
    return {
      datepickerLang: null,
    };
  },
  dependencies: ['localeService'],
  computed: {
    translation: {
      get() {
        return this.getTranslations();
      },
      set(value) {
        return value;
      },
    },
  },
  methods: {
    getTranslations() {
      return new Language(
        'Language name',
        [
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_long.1'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_long.2'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_long.3'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_long.4'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_long.5'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_long.6'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_long.7'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_long.8'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_long.9'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_long.10'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_long.11'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_long.12'),
        ],
        [
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_short.1'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_short.2'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_short.3'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_short.4'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_short.5'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_short.6'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_short.7'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_short.8'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_short.9'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_short.10'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_short.11'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datetime.months_short.12'),
        ],
        [
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datepicker.days_short.su'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datepicker.days_short.mo'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datepicker.days_short.tu'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datepicker.days_short.we'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datepicker.days_short.th'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datepicker.days_short.fr'),
          this.localeService.translateInLocale(this.datepickerLang, 'terms.datepicker.days_short.sa'),
        ],
      );
    },
    updateTranslations() {
      this.translation = this.getTranslations();
    },
  },
  beforeUpdate() {
    this.localeService.getUserLanguage().then(language => {
      if (this.datepickerLang !== language) {
        this.datepickerLang = language;
        this.updateTranslations();
      }
    });
  },
});

export default {
  props: {
    name: String,
    value: String,
    disabled: Object,
    placeholder: String,
    readonly: Boolean,
    id: String,
  },
  components: {
    datepicker: Datepicker,
  },
  computed: {
    internalDisabled() {
      const disabled = Object.assign({}, this.disabled);
      if (disabled.to) {
        disabled.to = apiToLocalDate(disabled.to);
      }
      if (disabled.to) {
        disabled.from = apiToLocalDate(disabled.from);
      }
      return disabled;
    },
    internalValue: {
      get() {
        return apiToLocalDate(this.value);
      },
      set(value) {
        this.$emit('input', localDateToApi(value).toISOString());
        return value;
      },
    },
  },
  methods: {
    onOpened() {
      if (!this.value) {
        let newValue = moment();

        if (this.disabled.from && newValue.isAfter(this.disabled.from)) {
          newValue = this.disabled.from.clone();
        }

        if (this.disabled.to && newValue.isBefore(this.disabled.to)) {
          newValue = this.disabled.to.clone();
        }

        this.$emit('input', newValue.toISOString());
      }

      this.$emit('toggle', true);
    },
    onClosed() {
      this.$emit('toggle', false);
    },
    hideDatepicker() {
      this.$refs.datepicker.close();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/correct-datepicker/CorrectDatepicker.js